export default __webpack_public_path__ + "assets/icons/freightEdit.b247cee6.svg";